( function () {
   
    'use strict';

    ( function ( $ ) {
        $(document).ready(function(){

            if($('.memberships-tab-main').length > 0){
                
                var group = $(".memberships-box .memberships-text-list");
                    var tallest = 0;
                    group.each(function(){
                    var currentHeight = $(this).height();
                    if(currentHeight > tallest) {
                        tallest = currentHeight;
                    }
                });
                group.height(tallest);

                $('.circks').click(function() {
                   // $('.memberships-bg-tab ul li').removeClass('active');
                   var totals = $('.ctypes li.active').length;
                   if ($(this).parent('li').hasClass('active')) {
                    if(totals != 1){
                        $(this).parent('li').removeClass('active');
                    }
                    } else {
                        $(this).parent('li').addClass('active');
                    }
                  
                    
                    var tab_attribs = [];
                    
                    $('.ctypes li.active').each(function () {
                        tab_attribs.push( $(this).data("id") );
                    });
                    var crickslug = tab_attribs;
                    var selctval = $('#subcat').val();
                    
                     $(".loaders").show();
                    $.ajax({
                        type: "POST",
                        cache: false,
                        url: ssAjax.ajaxurl,
                        data: { nonce: ssAjax.nonce, crickslug:crickslug,selctval:selctval, action: 'getmemebership' },
                        dataType: 'html',
                        success: function (responses) {
                            
                           //console.warn(responses);
                             $(".loaders").fadeOut();
                            // $(".fixtures-tab-detail").addClass('active');
                            $("#printdata").html("");
                            $("#printdata").html(responses);
                            var group = $(".memberships-box .memberships-text-list");
                                var tallest = 0;
                                group.each(function(){
                                var currentHeight = $(this).height();
                                if(currentHeight > tallest) {
                                    tallest = currentHeight;
                                }
                            });
                            group.height(tallest);
                        }
                    });
                });

                
                $('#subcat').on('change', function() {
                    //var crickslug = $('.memberships-bg-tab ul li.active').find('a').data("id");
                  //  var crickslug = '';
                    var tab_attribs = [];
                    
                    $('.ctypes li.active').each(function () {
                        tab_attribs.push( $(this).data("id") );
                    });
                    var crickslug = tab_attribs;
                    var selctval = $(this).val();
                    $(".loaders").show();
                    $.ajax({
                        type: "POST",
                        cache: false,
                        url: ssAjax.ajaxurl,
                        data: { nonce: ssAjax.nonce, crickslug:crickslug,selctval:selctval, action: 'getmemebership' },
                        dataType: 'html',
                        success: function (responses) {
                             $(".loaders").fadeOut();
                            $("#printdata").html("");
                            $("#printdata").html(responses);
                            var group = $(".memberships-box .memberships-text-list");
                                var tallest = 0;
                                group.each(function(){
                                var currentHeight = $(this).height();
                                if(currentHeight > tallest) {
                                    tallest = currentHeight;
                                }
                            });
                            group.height(tallest);
                        }
                    });
                });

            }

        });
        
    } )( jQuery );
} )();

